import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';

@Component({})
export default class VuePinCodeInput extends Vue {
  @Prop({ type: Number, default: 4 })
  readonly length!: number;

  @Prop({ type: Boolean, default: false })
  readonly error!: boolean;

  @Prop({ type: String, default: '' })
  readonly label!: string;

  public pinCode: string = '';

  public get hasError(): boolean {
    return this.error;
  }

  @Watch('error')
  onErrorChanged(val: boolean): void {
    if (val) {
      setTimeout(() => {
        this.pinCode = '';
      }, 500);
    }
  }

  public onKeyPress(digit: number): void {
    if (this.pinCode.length >= this.length) return;
    this.pinCode += digit.toString();
    this.$emit('input', this.pinCode);

    if (this.pinCode.length === this.length) {
      this.$nextTick(() => {
        this.$emit('complete', this.pinCode);
      });
    }
  }

  public onDelete(): void {
    if (this.pinCode.length === 0) return;
    this.pinCode = this.pinCode.slice(0, -1);
    this.$emit('input', this.pinCode);
  }

  public reset(): void {
    this.pinCode = '';
    this.$emit('input', this.pinCode);
  }
}
